import React, { useState } from 'react';
import { Link, Icon } from '../../../../ui-kit';
import { getUser } from '../../../../common/utils';
import CommentV2 from '../../components/Comment/components/CommentV2';
import './_replies.scss';

const RepliesV2 = ({ commentData, ...rest }) => {
  const { children: replies } = commentData;
  const [showAllReplies, setShowAllReplies] = useState(false);

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const visibleReplies = showAllReplies || (replies?.length ?? 0) <= 2 ?
  replies :
  replies.slice(-1);

  return (
    <div className="comment-v2-replies">
      {(replies?.length ?? 0) > 2 &&
      <Link
        onClick={() => setShowAllReplies(!showAllReplies)}
        className="comment-v2-replies--toggle-more-replies">

          {showAllReplies ?
        'Hide replies' :
        `View ${replies.length - visibleReplies.length} more replies`}
          <Icon name={showAllReplies ? 'arrowup' : 'arrowdown'} color="slateBlueGray" size={8} />
        </Link>}

      {replies?.length &&
      <div
        role="button"
        tabIndex={0}
        className="comment-v2-replies--container"
        onMouseOver={stopPropagation}
        onMouseLeave={stopPropagation}
        onFocus={stopPropagation}>

          {visibleReplies.map((reply) =>
        <div className="comment-v2-replies--container-reply" key={`reply-${reply.commentId}`}>
              <CommentV2
            {...rest}
            isChildren
            key={reply.commentId}
            user={getUser(reply.createdByUser)}
            commentIndex={reply.commentId}
            comment={reply}
            parentComment={commentData} />

            </div>
        )}
        </div>}

    </div>);

};

export default RepliesV2;